var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component } from 'vue-property-decorator';
import linker from '../linker';
import { CurrentNewsItem } from './molecules';
import { NewsService } from '../services/NewsService';
var CurrentNews = (function (_super) {
    __extends(CurrentNews, _super);
    function CurrentNews() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.newsItems = [];
        _this.topItem = null;
        return _this;
    }
    CurrentNews.prototype.mounted = function () {
        this.load();
    };
    CurrentNews.prototype.load = function () {
        var _this = this;
        new NewsService().loadNews(6, !window.location.search.match(/(\?|\&)Vorschau($|\=|\&)/)).then(function (items) {
            _this.topItem = items.shift();
            _this.newsItems = items;
        });
    };
    CurrentNews = __decorate([
        Component({
            components: {
                CurrentNewsItem: CurrentNewsItem,
            },
        })
    ], CurrentNews);
    return CurrentNews;
}(Vue));
export default CurrentNews;
linker.register('currentNews', CurrentNews);
